import DealsTask from './DealsTask'
export default DealsTask
